
import React, { useEffect, useState } from "react";
import styles from "./detailedList.module.css";
import { fetchThumbnailCached } from "../../util_glob"; // Adjust the import path as

import { IDocument } from "./../../interfaces";


const ThumbnailImage = ({ item, companyId, show }: { item: IDocument, companyId: string, show: boolean }) => {
    const [thumbnailUrl, setThumbnailUrl] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

        const loadThumbnail = async () => {
            if (thumbnailUrl == "") {
                setIsLoading(true);
                try {
                    const url = await fetchThumbnailCached(item.fileid.toString(), item.dateModified, item.ownerid, companyId);
                    setThumbnailUrl(url);
                } catch (error) {
                    console.error("Failed to load thumbnail:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };
        if (show) loadThumbnail();
    }, [show]);

    return (
            isLoading ? (
                <div className={styles.toolThumbCont}>

                    <div style={{ height: "50vh", aspectRatio: "auto", maxWidth: "60vw" }}>Loading...</div>
                </div>
            ) : thumbnailUrl ? (
                <div className={styles.toolThumbCont}>
                    <div className={styles.fileTooltipContent}>{item.name}</div>
                    <div className={styles.toolImgWrap}>
                        <img className={styles.toolImg} src={thumbnailUrl} />
                    </div>

                </div>
            ) : <div></div>

    );
};


export default ThumbnailImage;